import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Params } from '@angular/router';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Globals } from './../../globals'
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-finish-manage-import',
  templateUrl: './finish-manage-import.component.html'
})
export class FinishManageImportComponent implements OnInit {
  public postId: string;
  public approvedNumber: string;
  public approvedDate: string;
  public codigo: string;
  public nombreturista: string;
  public pasaporte: string;
  public numeroserial: string;
  public fecharegistro: string;
  public email: string;
  public estado;
  public salidaaduana;
  public errorMessage;
  public okMessage;
  public titulo: string = "Gestionar Importación";
  public lenguajeGlobal;

  Seccionales: SeccionalAduanera[];
  finish: Finish;

  import: Import;
  imports: Import[];
  extend: Extend;
  extends: Extend[];
  user: User;

  ShowLoadedFiles = false;
  public EditarShow: boolean = false;

  public sendmail: SendMail;

  public tooladuanaSalida: string;
  public tooltipoFinalizacion: string;

  finishForm = this.formBuilder.group({
    aduanaSalida: new FormControl('', [Validators.required]),
    tipoFinalizacion: new FormControl('', [Validators.required]),
    customTarget: new FormControl('')
  });

  public showModalBoxsave = false;
  showModalRequired: boolean = false;
  public ProrrogaShow = false;

  constructor(private http: HttpClient, private router: Router, private rutaActiva: ActivatedRoute, private formBuilder: FormBuilder, private globals: Globals, private cookies: CookieService) {
    var token = this.cookies.get("tokensessionFuncionario");
    var lenguaje = this.cookies.get("lenguajeFuncionario");
    this.lenguajeGlobal = lenguaje;
    if (token == "") {
      window.location.href = environment.redirecturl;
    }
    else {
      this.http.get<any>(`${environment.baseUrl}v1/sessionfuncionario/1?token=` + this.cookies.get("tokensessionFuncionario"))
        .subscribe({
          next: data => {
            this.user = data as User;

            this.globals.tipoDocumento = this.user.tipoDocumento;
            this.globals.numIdentificacion = this.user.numIdentificacion;
            this.globals.nombres = this.user.nombres;
            this.globals.apellidos = this.user.apellidos;
            this.globals.seccional = this.user.seccional;
            this.globals.idSeccional = this.user.idSeccional;
            this.globals.dependencia = this.user.dependencia;
            this.globals.idDependencia = this.user.idDependencia;
            this.globals.correo = this.user.correo;
            this.globals.activo = this.user.activo;
            this.globals.roles = this.user.rolesAutorizados.split(",");

            for (let i = 0; i < this.globals.roles.length; i++) {
              if (this.globals.roles[i] == "3244") {
                this.globals.r3244 = true;
              }
              if (this.globals.roles[i] == "3246") {
                this.globals.r3246 = true;
              }
              if (this.globals.roles[i] == "3247") {
                this.globals.r3247 = true;
              }
            }
          },
          error: error => {
            this.errorMessage = error.message;
          }
        })
    }
  }

  get customTargetValue() { return this.finishForm.get('customTarget'); }

  ngOnInit() {
    var lenguaje = this.cookies.get("lenguajeFuncionario");
    this.lenguajeGlobal = lenguaje;
    let element: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element.click();
    this.postId = this.rutaActiva.snapshot.params.postid
    //this.salidaaduana = (this.rutaActiva.snapshot.params.salidaaduana == "undefined" ? "" : this.rutaActiva.snapshot.params.salidaaduana);
    //var idStatus = this.rutaActiva.snapshot.params.estado    
    
    
    this.http.get<any>(`${environment.baseUrl}v1/parametros/1?codigo=`)
      .subscribe({
        next: data => {
          this.Seccionales = data as SeccionalAduanera[];          
          
          this.EditarShow = true;
          this.http.get<any>(`${environment.baseUrl}v1/import/1?email=&numeroserial=&status=&passportnumber=&importdate=&idimport=` + this.postId + "&approvednumber=&sectionaladdresin=")
            .subscribe({
              next: data => {
                this.imports = data as Import[];
                this.import = this.imports[0];

                this.nombreturista = this.import.touristName;
                this.pasaporte = this.import.passportNumber;
                this.fecharegistro = this.import.importDate.substring(0, 10);
                this.numeroserial = this.import.chassisNumber;
                this.email = this.import.email;
                this.codigo = this.import.nombreContenedor + "-finalizar"
                this.salidaaduana = this.import.sectionalAddressOut;
                this.approvedNumber = this.import.approvedNumber
                this.approvedDate = this.import.approvedDate
                var idStatus = this.import.idStatus

                this.estado = (idStatus == "1" ? "En revisión" : (idStatus == "2" ? "Aprobada" : (idStatus == "3" ? "Rechazada" : (idStatus == "4" ? "Solicitud prórroga" : (idStatus == "5" ? "Prórroga aprobada" : (idStatus == "6" ? "Vencida" : (idStatus == "7" ? "Finalizada" : "")))))))

                this.finishForm.patchValue({
                  aduanaSalida: this.salidaaduana
                });

                if (this.import.idStatus == "7") {
                  this.EditarShow = false;
                  this.finishForm.controls["aduanaSalida"].disable();
                  this.finishForm.controls["tipoFinalizacion"].disable();

                  this.http.get<any>(`${environment.baseUrl}v1/finish/1?idimport=` + this.postId)
                    .subscribe({
                      next: data => {
                        this.finish = data as Finish;
                        this.finishForm.patchValue({
                          aduanaSalida: this.finish.sectionalAddressOut,
                          tipoFinalizacion: this.finish.finishType 
                        });

                        this.tooladuanaSalida = this.Seccionales.filter(se => se.codigo == this.finish.sectionalAddressOut)[0].nombre;
                        this.tooltipoFinalizacion = (this.finish.finishType == "1" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Salida en término" : "Term output") :
                          (this.finish.finishType == "2" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Salida con multa" : "Departure with fine") :
                            (this.finish.finishType == "3" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Aprehensión" : "Apprehension") :
                              (this.finish.finishType == "4" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Destrucción total" : "Total destruction") :
                                (this.finish.finishType == "5" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Abandono voluntario" : "Voluntary abandonment") :
                                  (this.finish.finishType == "6" ? (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Legalización" : "Legalization") :
                                    (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es" ? "Salida sin reporte del turista" : "No report output tourists")))))))
                      },
                      error: error => {
                        this.errorMessage = error.message;
                      }
                    })
                }

                this.finishForm.patchValue({
                  aduanaSalida: this.salidaaduana
                });

                this.ShowLoadedFiles = true;

                let element1: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                element1.click();

                this.http.get<any>(`${environment.baseUrl}v1/extend/1?idImport=` + this.import.id + "&sectionaladdress=&status=&idextend=")
                  .subscribe({
                    next: data => {
                      this.extends = data as Extend[];
                      this.extend = this.extends[0];

                      if (this.extend == null) {
                        this.ProrrogaShow = false;
                      }
                      else {
                        this.ProrrogaShow = true;
                        for (let e in this.extends) {
                          this.extends[e].estado = (this.extends[e].idStatus == "1" ? "EN REVISIÓN" : (this.extends[e].idStatus == "2" ? "APROBADA" : (this.extends[e].idStatus == "3" ? "RECHAZADA" : (this.extends[e].idStatus == "4" ? "SOLICITUD PRÓRROGA" : (this.extends[e].idStatus == "5" ? "PRORROGA APROBADA" : (this.extends[e].idStatus == "6" ? "VENCIDA" : (this.extends[e].idStatus == "7" ? "FINALIZADA" : "")))))))
                          this.http.get<any>(`${environment.baseUrl}v1/parametros/8?codigo=` + this.extends[e].sectionalAddress)
                            .subscribe({
                              next: data => {
                                var seccional = data as SeccionalAduanera;
                                this.extends[e].sectionalName = seccional.nombre;
                              }
                            })
                        }
                      }
                    },
                    error: error => {
                      this.errorMessage = error.message;
                      //console.error('There was an error!', error);
                    }
                  })
              },
              error: error => {
                this.errorMessage = error.message;
                //console.error('There was an error!', error);
                let element2: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
                element2.click();
              }
            })
        },
        error: error => {
          this.errorMessage = error.message;
          //console.error('There was an error!', error);
          let element3: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
          element3.click();
        }
      })
  }

  savefinish() {
    let element: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element.click();
    if (this.finishForm.valid) {
      
      

      this.finish = new Finish();
      this.finish.idImport = this.postId;
      this.finish.finishType = this.finishForm.controls["tipoFinalizacion"].value;
      this.finish.sectionalAddressOut = this.finishForm.controls["aduanaSalida"].value;
      this.finish.managerUserName = this.user.nombres + " " + this.user.apellidos;
      this.finish.managerUserId = this.user.numIdentificacion;

      const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
      this.http.post<string>(`${environment.baseUrl}v1/finish`, this.finish, { headers })
        .subscribe({
          next: data => {
            this.postId = data;
            let element4: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
            element4.click();

            if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
              this.okMessage = "¡Solicitud finalizada con éxito!";
            } else {
              this.okMessage = "Application completed successfully!";
            }
            this.EditarShow = false;
            this.finishForm.controls["aduanaSalida"].disable();
            this.finishForm.controls["tipoFinalizacion"].disable();
            let element3: HTMLElement = document.getElementById('abrirmodal') as HTMLElement;
            element3.click();

            this.http.get<any>(`${environment.baseUrl}v1/token/1`)
              .subscribe({
                next: data => {
                  this.sendmail = data as SendMail;
                  this.sendmail.asunto = "Finalización de la importación temporal de turismo";
                  this.sendmail.email = this.import.email;
                  this.sendmail.emailCopy = "null";
                  this.sendmail.mensaje = "<table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td><table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td style='font-size: 25px; font-family: Helvetica, Arial, sans-serif; color: #262944; padding-top: 30px;' class='padding-copy'><b>Notificación de servicio</b><br/><span style='font-size: 20px;'>Finalización de la importación temporal de turismo</span> </td></tr><tr><td style='padding: 30px 0 0 0; font-size: 16px; line-height: 22px; font-family: Helvetica, Arial, sans-serif; color: #2B323D;' class='padding-copy'><p>Buen día,</p><p><span style='font-weight: bold;'>" + this.import.touristName + "</span></p><p style='padding: 30px 0 0 0;'>Tu solicitud de <span style='font-weight: bold;'>importación temporal de turismo</span> del medio de transporte con número de identificación (VIN o Serial) <span style='font-weight: bold;'>" + this.import.chassisNumber + "</span> ha sido:</p><table width='100%' border='0' cellspacing='0' cellpadding='0' class='mobile-button-container'><tr><td align='center' style='padding: 25px 0 0 0;' class='padding-copy'><table border='0' cellspacing='0' cellpadding='0' class='responsive-table'><tr><td align='center'><a style='border: 0;background: #FFFFFF;display: inline-block;text-align: center;padding: 5px 20px 5px 20px;border: 2px solid #7C7C7C;outline: none;color: #7C7C7C;font-size: 16px;font-family: WorkSans-Bold;border-radius: 5px;transition: 0.25s;cursor: none;'><b>Finalizada</b></a></td></tr></table></td></tr></table><p style='padding: 30px 0 0 0;'>Descripción del tipo de finalización: <span style='font-weight: bold;'>" + (this.finish.finishType == "1" ? "Salida en término" : (this.finish.finishType == "2" ? "Salida con multa" : (this.finish.finishType == "3" ? "Aprehensión" : (this.finish.finishType == "4" ? "Destrucción total" : (this.finish.finishType == "5" ? "Abandono voluntario" : (this.finish.finishType == "6" ? "Legalización" : "Salida sin reporte del turista")))))) + "</span></p><p style='padding: 40px 0 0 0;'>Cordialmente,</p><p><span style='font-weight: bold;'>Dirección de Impuestos y Aduanas Nacionales - DIAN</span></p><p style='padding: 0 0 0 0;'>Gestión de Operación Aduanera</p></td></tr></table></td></tr></table>";

                  this.http.post<string>(`${environment.baseUrl}v1/sendmail`, this.sendmail, { headers })
                    .subscribe({
                      next: data => {

                      },
                      error: error => {
                        this.errorMessage = error.message;
                      }
                    })
                },
                error: error => {
                  this.errorMessage = error.message;
                }
              })
          },
          error: error => {
            this.errorMessage = error.message;
            //console.error('There was an error!', error);
            let element5: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
            element5.click();
          }
        })

    } else {      
      let element6: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
      element6.click();      
      let element7: HTMLElement = document.getElementById('abrirmodalerror') as HTMLElement;
      element7.click();
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.errorMessage = "Algunos datos obligatorios están sin diligenciar o están mal diligenciados, por favor";
      } else {
        this.errorMessage = "Some mandatory information is incomplete or incorrectly filled out, please";
      }
    }
  }

  salir() {
    this.router.navigate(["/finish-import"]);
  }

  onSearchClick() {
    this.router.navigate(["/import-back/" + "consulta" + "/" + this.email + "/" + this.numeroserial + "/" + this.postId + "/finish-manage-import"]);
  }

  verprorroga(idImport, id) {
    this.router.navigate(["/extension-back/consulta/" + idImport + "/" + id +"/finish-manage-import"]);
  }
}

class Finish {
  id: string;
  idImport: string;
  finishType: string;
  finishDate: string;
  sectionalAddressOut: string;
  managerUserName: string;
  managerUserId: string;
}

interface SeccionalAduanera {
  codigo: string;
  nombre: string;
}

class Import {
  id: string;
  sectionalAddressIn: string;
  sectionalAddressOut: string;
  touristName: string;
  touristCountry: string;
  passportNumber: string;
  nationality: string;
  dateOfArrival: string;
  touristCity: string;
  touristAddress: string;
  authorizedDuration: string;
  email: string;
  dateIn: string;
  dateOut: string;
  vehicleEntryForm: string;
  transportDocumentNumber: string;
  n1166DocumentNumber: string;
  ownershipDocumentNumber: string;
  registrationDate: string;
  typeClass: string;
  chassisNumber: string;
  licensePlate: string;
  make: string;
  model: string;
  engineNumber: string;
  countryOfRegistration: string;
  color: string;
  transportationName: string;
  nameFlag: string;
  entryPlace: string;
  registrationNumber: string;
  transportationChars: string;
  othersChars: string;
  idStatus: string;
  importDate: string;
  nombreContenedor: string;
  approvedNumber: string;
  approvedDate: string;
}

class Extend {
  id: string;
  sectionalAddress: string;
  sectionalName: string
  authorizedDuration: string;
  initialDate: string;
  endDate: string;
  touristCity: string;
  touristAddress: string;
  justification: string;
  authorization: string;
  tIDAssignee: string;
  iDAssignee: string;
  nameAssignee: string;
  emailAssignee: string;
  registrationDate: string;
  idImport: string;
  idStatus: string;
  estado: string;
  justificationRejection: string;
}

class SendMail {
  asunto: string;
  email: string;
  mensaje: string;
  emailCopy: string;
  token: string;
}

class User {
  idToken: string;
  clientId: string;
  tipoDocumento: string;
  numIdentificacion: string;
  nombres: string;
  apellidos: string;
  seccional: string;
  idSeccional: string;
  dependencia: string;
  idDependencia: string;
  correo: string;
  activo: string;
  rolesAutorizados: string;
  infouser: string;
}
